module.exports = "/images/logo-sobatppt-light-013d4cc5463ddbafee11d955752bb062.png";